<script>
import BaseButton from "@/components/base-button.vue";

export default {
  name: "repeat-dialog",
  components: {BaseButton},
  props: {
    visible: {
      type: Boolean,
    },
  },
  computed: {
    dialog: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    handleClick() {
      this.dialog = false
    }
  },
}
</script>

<template>
  <v-dialog
      v-model="dialog"
      persistent
  >
    <div class="repeat-dialog">
      <img class="repeat-dialog__icon" src="@/assets/imgs/repeat-dialog-icon.svg"/>
      <div class="repeat-dialog__text">El número celular se ha enviado correctamente. El equipo de ventas de Mstar lo
        contactará pronto.
      </div>
     <base-button data-track-widget-id="repeat-dialog-button" data-track-widget-label="Lo entiendo" label="Lo entiendo" @click="handleClick" />
    </div>
  </v-dialog>
</template>

<style scoped lang="less">
.repeat-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.repeat-dialog__icon {
  width: 4rem;
  height: 4rem;
}

.repeat-dialog__text{
  margin: 0.75rem 0 1.25rem 0;
  color: #020617;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: center;
}

.repeat-dialog__btn{

}
</style>